<template>
  <DBox
    :id="'cmp-setting-identities-sidewindow_identities-shares_email_text_email'"
    :addButton="false"
    :addLink="false"
    :rightMenu="[]"
    @menuClick="onRightMenuClick"
  >
        <!-- {
        text: 'Preview Email',
        value: 'preview_email',
      },
      {
        text: 'Save',
        value: 'save',
      }, -->
    <div
      class="
        cmp-setting-identities-sidewindow_identities-shares_email_text_email
      "
    >
      <!-- <TextField2
          :id="'logo_url'"
          :label="$t('logo_url')"
          v-bind="textFieldConfig"
          :value="text_element.logo_url"
          :placeholder="$t('logo_url')"
          @valuechanged="(name, value) => onTextValueChange(name, value)"
        /> -->
      <div class="fc2 fc2-row ut-flex">
        <div style="display: flex; margin-right: 60px; align-items: center">
          <label class="fc2-label txtov">{{ $t("logo_url_string") }} </label>
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            width: 100%;
            justify-content: center;
            align-items: flex-start;
          "
          class="ut-flex no-left-padding"
        >
          <div style="display: flex; width: 100%">
            <TextField2
              bb="0px"
              :showLabel="false"
              :id="'logo_url'"
              v-bind="textFieldConfig"
              :value="text_element.logo_url"
              :placeholder="$t('logo_url_string')"
              @blur="onTextValueChange"
            />
            <div :title="$t('detailsb2b_logo_help1')" class="dt-icon-container">
              <img
                src="static/icons/question-dark.svg"
                class="dt-icon v5 s3"
                alt
              />
            </div>
          </div>
          <div
            v-if="text_element.logo_url"
            style="
              width: 84px;
              height: fit-content;
              background: rgb(234, 234, 234) no-repeat padding-box;
              border-radius: 4px;
              opacity: 1;
              text-align: center;
              margin: 4px 0;
              padding: 2px 0px;
            "
          >
            <img width="60" :src="text_element.logo_url" alt />
          </div>
        </div>
      </div>
      <TextField2
        :id="'sender_name'"
        :label="$t('sender_name')"
        v-bind="textFieldConfig"
        :value="text_element.sender_name"
        :placeholder="$t('sender_name')"
        @blur="onTextValueChange"
      />
      <TextField2
        :id="'reply_to'"
        :label="$t('reply_to')"
        v-bind="textFieldConfig"
        :value="text_element.reply_to"
        :placeholder="$t('reply_to')"
        @blur="onTextValueChange"
      />
      <TextField2
        :id="'subject_b2b'"
        :label="$t('email_subject')"
        v-bind="textFieldConfig"
        :value="text_element.subject_b2b"
        :placeholder="$t('email_subject')"
        @blur="onTextValueChange"
      />
      <TextField2
        :id="'b2b_leading'"
        :label="$t('email')"
        v-bind="textFieldConfig"
        :value="text_element.b2b_leading"
        :placeholder="$t('Type in Text before Statement Button...')"
        textarea
        :height="130"
        @blur="onTextValueChange"
      />
      <div
        style="
          display: flex;
          height: 32px;
          border-bottom: 1px solid var(--sprt-85);
          justify-content: flex-start;
          align-items: center;
          flex-direction: row;
          background-color: var(--bc-820);
        "
      >
        <div
          style="
            color: var(--text-5);
            white-space: nowrap;
            padding-right: 15px;
            padding-left: 10px;
          "
        >
          {{$t('placeholder_button')}}
        </div>
        <div
          style="
            border: 1px solid #50505080;
            color: var(--text-5);
            padding: 0 4px;
            border-radius: 3px;
          "
        >
          {{$t('access_statement')}}
        </div>
      </div>
      <TextField2
        :id="'b2b_trailing'"
        :label="$t('email')"
        v-bind="textFieldConfig"
        :value="text_element.b2b_trailing"
        :placeholder="$t('Type in Text after Statement Button...')"
        textarea
        :height="130"
        @blur="onTextValueChange"
      />
    </div>
  </DBox>
</template>
    <script>
import {
  createTextFieldConfig,
  EventHooks,
} from "../../../../plugins/text-field";
import DBox from "@dtplugins/dbox/dbox";
import { NotificationService } from "@dtplugins/notification/notification.service";
export default {
  components: {},
  props: {
    invoiceProjectDetails: {
      type: Object,
    },
  },
  data() {
    return {
      emailTemplate: { subject: "", template_text: "" },
      textFieldConfig: createTextFieldConfig({
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        valueChangedEvent: EventHooks.OnBlur,
      }),
    };
  },

  computed: {
    text_element: function () {
      return this.invoiceProjectDetails?.invoice_project?.text_elements || {};
    },
  },
  methods: {
    // onRightMenuClick: async function (menu) {
    //   if (menu == "save") {
    //     this.$emit("updated", {
    //       text_elements: this.text_element,
    //       invoice_project_id:
    //         this.invoiceProjectDetails?.invoice_project?.invoice_project_id,
    //     });
    //   }
    // },
    onRightMenuClick: async function (menu) {
      if (menu == "save") {
        this.$emit("updated", {
          text_elements: this.text_element,
          invoice_project_id:
            this.invoiceProjectDetails?.invoice_project?.invoice_project_id,
        });
        setTimeout(() => {
          NotificationService.showNotification({
            text: "Email Settings updated",
            timeout: 5000,
          });
        }, 10);
      } else if (menu == "preview_email") {
        let template =
          this.invoiceProjectDetails?.invoice_project?.b2b_email_template;
        template = template
          .replace(
            "[% b2b_email_leading_text %]",
            this.text_element.b2b_leading || ""
          )
          .replace(
            "[% b2b_email_trailing_text %]",
            this.text_element.b2b_trailing || ""
          )
          .replace("[% logo_url %]", this.text_element.logo_url || "");

        let newWindow = window.open();
        newWindow.document.write(template);
      }
    },
    onTextValueChange: function ({ name, value }) {
      this.text_element[name] = value;
      this.$emit('updateTextElement',this.text_element)
      console.log(" this.text_element", this.text_element);
    },
  },
};
</script>
    
    <style lang="scss">
.cmp-setting-identities-sidewindow_identities-shares_email_text_email {
  .fc2-row {
    --bb: 1px solid var(--sprt-85);
    display: flex;
    flex-direction: row;
    align-items: flex-start;

    .fc2-label,
    .icon,
    .title {
      flex: 1;
    }
    .fc2-label,
    .title-txt {
      max-width: 115px;
    }
    > .ut-flex {
      flex: 1;
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      outline: none;

      &.no-left-padding {
        padding-left: 0;
      }

      span {
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .fc2-textfield {
      width: 100%;
    }
    .icon {
      min-height: 22px;
      justify-content: flex-end;
    }
  }
}
</style>
    